import { render } from "./Footer.vue?vue&type=template&id=586342e4"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=586342e4&lang=css"

import exportComponent from "D:\\node projects\\jsmethod\\vue-app\\homepage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__